var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-4 w-100"},[_c('b-form-group',{staticClass:"mb-0"},[_c('validated-attribute-input',{attrs:{"config":_vm.config,"parent-feature":_vm.parentFeature,"validation-methods":_vm.validationMethods,"disabled":_vm.disabled,"disabledReason":_vm.disabledReason,"input-type":"hidden"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }